import React from 'react';
import './Skeleton.css';

function Skeleton({ width = '100%', height = 16, borderRadius = 6, style = {} }) {
  return (
    <div className="sk-base" style={{ width, height, borderRadius, ...style }} />
  );
}

Skeleton.Text = function SkeletonText({ lines = 3, lastWidth = '65%' }) {
  return (
    <div className="sk-text">
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton key={i} width={i === lines - 1 && lines > 1 ? lastWidth : '100%'} height={14} />
      ))}
    </div>
  );
};

Skeleton.Card = function SkeletonCard() {
  return (
    <div className="sk-card">
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 12 }}>
        <Skeleton width={36} height={36} borderRadius={8} />
        <div style={{ flex: 1 }}>
          <Skeleton width="55%" height={14} style={{ marginBottom: 6 }} />
          <Skeleton width="35%" height={11} />
        </div>
      </div>
      <Skeleton.Text lines={2} lastWidth="70%" />
    </div>
  );
};

Skeleton.Table = function SkeletonTable({ rows = 5, cols = 4 }) {
  return (
    <div className="sk-table">
      <div className="sk-table-row sk-table-header">
        {Array.from({ length: cols }).map((_, i) => (
          <Skeleton key={i} height={12} width="60%" />
        ))}
      </div>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="sk-table-row">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} height={13} width={c === 0 ? '75%' : '55%'} />
          ))}
        </div>
      ))}
    </div>
  );
};

export default Skeleton;
